import { ref } from '@vue/composition-api'
import nominationsApi from '@/services/api/nominations'

export default function useNominationAccountDetail() {
  const data = ref(null)
  const loading = ref(false)

  async function fetch(draftId, params) {
    loading.value = true
    try {
      const res = await nominationsApi.accountDetail(draftId, params)
      data.value = res.data.data
    } finally {
      loading.value = false
    }
  }

  return { data, loading, fetch }
}



// WEBPACK FOOTER //
// ./src/composables/nominations/useNominationAccountDetail.js